/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

export const FACET_PRICE_PREFIX = 'price_';
export const FACET_CATEGORY_VALUE = 'parentCatgroup_id_search';
export const FACET_CATEGORY_ENTRY_VALUE_PREFIX = 'path.tree:';
export const FACET_LIMIT_SUFFIX = ':-1';
